import { getScreenWidth } from '../utils/getScreenWidth.js';

function getLinksPosition({ links, user, config }) {
  const width = getScreenWidth();

  const userConfig = config[user.type];
  let firstInDropdown = '';
  let dotAllowed = true;

  const navLinks = [];
  const dropdownLinks = [];

  userConfig.forEach(({ width: breakpointWidth, firstElementInDropdown, dotAllowed: allowDot }) => {
    if (width > breakpointWidth) {
      firstInDropdown = firstElementInDropdown;
      dotAllowed = allowDot;
    }
  });

  links.forEach((link) => {
    const startedAddingToDropdown = dropdownLinks.length > 0;
    const addToDropdown = firstInDropdown === 'ALL' || link.name === firstInDropdown || startedAddingToDropdown;

    if (addToDropdown) {
      dropdownLinks.push(link);
    } else {
      navLinks.push(link);
    }
  });

  return { navLinks, dropdownLinks, dotAllowed };
}

export default getLinksPosition;
